import { useState } from "react";
import Logo from "../Assets/Brikitt Logo.png";
import dropdown from "../Assets/dropdown.png"
import headphone from "../Assets/headphone.png"
import world from "../Assets/world.png"
import {GiHamburgerMenu} from "react-icons/gi"
import {AiFillCloseCircle} from "react-icons/ai"
// import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
// import Stack from '@mui/material/Stack';
// import Paper from '@mui/material/Paper';
const Navbar=()=>
{
    const[open,setopen]=useState(false)
    const[companyopen,setcompanyopen]=useState(false)
    const[copen,setcopen]=useState(false)
    return(
        <>
        <div style={{fontFamily:"Public Sans"}} className="sm:px-[30px] w-[full] flex justify-between items-center gap-20 py-[22px] bg-[#0F0E0A] text-[white] text-[13px] font-[500] lg:px-[100px]">
            <div className="flex items-center gap-[100px]">
                <a href="https://brikitt.com/" className=" cursor-pointer lg:w-[140px] sm:w-[120px] h-[40px]">
                    <img src="https://brikitt.com/wp-content/uploads/2022/07/Horezantal-Logo-BRIkitt-1.png"></img>
                </a>
                {/* <div className="sm:hidden lg:flex justify-evenly gap-20 text-[13px] ">
                    <a>Vacation Rental Management</a>
                    <a>Real Estate</a>
                    <div onClick={()=>setcompanyopen(!companyopen)} className="cursor-pointer flex justify-between gap-2 items-center">
                        <p>Company</p>
                        <img src={dropdown}></img>
                    </div>
                    
                </div> */}
            </div>
            <div className="sm:hidden lg:flex justify-between gap-2 items-center text-[13px]">
                    {/* <p>My Account</p>
                    <img src={dropdown}></img> */}
            </div>
            {/* <div className="sm:hidden lg:flex justify-evenly gap-[30px] text-[13px] ">
                <div className="flex justify-between gap-2 items-center">
                    <img src={world} />
                    <img src={dropdown}></img>
                </div>
                <div className="sm:hidden lg:flex justify-between gap-2 items-center">
                    <img src={headphone} />
                    <img src={dropdown}></img>
                </div>
            </div> */}
            <div style={{fontFamily:"Inter"}} className="cursor-pointer sm:flex lg:hidden flex items-center gap-[25px] text-[14px] font-[600] leading-[30px] tracking-[1px]">
                {/* <p className=" border-r-2 px-[20px] tracking-[1px]">Login</p>
                <p className="">Sign Up</p> */}
                {/* <GiHamburgerMenu className="" color="white" size="20px" cursor="pointer" onClick={()=>setopen(true)}/> */}
            </div>
            
            <div style={{display:open?"block":"none"}} className="bg-black flex flex-col px-[35px] py-[15px] border-2 border-white absolute top-[10%] left-[40%] z-10 ease-in">
                <div className="flex gap-x-[20px] items-start">
                    <div className="leading-[35px]">
                        <a>Vacation Rental Management</a><br/>
                        <a>Real Estate</a><br/>
                        <div onClick={()=>setcopen(!copen)} className="cursor-pointer flex gap-2 items-center">
                            <p>Company</p>
                            <img src={dropdown}></img>
                        </div>
                        <div className="px-[20px]" style={{display:copen?"block":"none"}}>
                            <a>About Us</a><br/>
                            <a>Innovations</a><br/>
                            <a>Newsroom</a><br/>
                            <a>Solutions and Partnerships</a><br/>
                            <a>Blog</a><br/>
                            <a>Careers</a><br/>
                        </div>
                        <div className="flex gap-2 items-center">
                            <p>My Account</p>
                            <img src={dropdown}></img>
                        </div>
                    </div>
                    <AiFillCloseCircle onClick={()=>setopen(false)} />
                </div>

            </div>
            
        </div>
        {/* <div style={{display:companyopen?"block":"none"}} className="absolute sm:hidden lg:block bg-black text-white px-[40px] py-[20px] left-[40%]">
            <a>About Us</a><br/>
            <a>Innovations</a><br/>
            <a>Newsroom</a><br/>
            <a>Solutions and Partnerships</a><br/>
            <a>Blog</a><br/>
            <a>Careers</a><br/>
        </div> */}
        </>
    )
}
export default Navbar